const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const LINE_ENCRYPT_KEY = process.env.REACT_APP_LINE_ENCRYPT_KEY;
const LINE_ENCRYPT_IV = process.env.REACT_APP_LINE_ENCRYPT_IV;

export default {
  API_BASE_URL,
  LINE_ENCRYPT_KEY,
  LINE_ENCRYPT_IV,
};
